import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ethers } from 'ethers';
import './Table.css';
import AlertWithUrl from './AlertWithUrl';

import {
    catastropheBondsFactoryAddress_Fuji,
    catastropheBondsFactoryAddress_Amoy,
    rpcUrl_Amoy,
    rpcUrl_Fuji,
    catastropheBondsCollateralPoolAddress_Fuji,
    catastropheBondsCollateralPoolAddress_Amoy,
    chainSelector_Fuji,
    chainSelector_Amoy
} from "../config/config.js";

import catastropheBondsFactoryAbi from "../config/abis/catastropheBondsFactory.json";

import catastropheBondAbi from "../config/abis/catastropheBond.json";

import catastropheBondsCollateralPoolAbi from "../config/abis/catastropheBondsCollateralPool.json";

const catastropheBondsCollateralPoolContractInterface = ethers.Interface.from(catastropheBondsCollateralPoolAbi);

function Portfolio() {
    const [txSuccess, setTxSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [messageId, setMessageId] = useState('');

    const [portfolio_settledPositions, setPortfolio_settledPositions] = useState([]);
    const [portfolio_unsettledPositions, setPortfolio_unsettledPositions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [isRedeeming, setIsRedeeming] = useState({});

    const [showModal, setShowModal] = useState(false); // State to control modal visibility

    const [positionTokenAddress, setPositionTokenAddress] = useState('');
    const [contractAddress, setContractAddress] = useState('');
    const [price, setPrice] = useState(0);
    const [positionType, setPositionType] = useState('');

    const [modalTitle, setModalTitle] = useState('');
    const [isLoadingPositionTokenApproval, setIsLoadingPositionTokenApproval] = useState({})
    const [isLoadingPositionTokenListingForSale, setIsLoadingPositionTokenListingForSale] = useState({})
    const [isLoadingPositionTokenUnlistingFromSale, setIsLoadingPositionTokenUnlistingFromSale] = useState({})

    const rootUrl = 'https://europe-west3-shamba-oracle-services.cloudfunctions.net/shamba-ecofutures-api'
    const secretKey = "98bdb732d7eb03dc78a1f7734cf4498f60f6fa677de4d9599b99e2bbcefcb59f"
    const EcoFuturesContractFactoryMPX_Address = "0x8675ED8cbeEb00fF18a6C3EcFB5bF608a830A3E5"
    const EcoFuturesCollateralPool_Address = "0x533309989F93CBCeB69052a259A4B9CCea66A9c7"
    const EcoFuturesMarketplace_Address = "0x424484C399b417e40482FcdbEb1B9dB48d253E88"


    const sleep = ms => new Promise(r => setTimeout(r, ms));

    let catastropheBondsCollateralPoolContract;
    async function getAllCatastropheBonds() {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            let catastropheBondsFactoryContract;

            if (chainId == 43113) {
                catastropheBondsFactoryContract = new ethers.Contract(catastropheBondsFactoryAddress_Fuji, catastropheBondsFactoryAbi, provider);
                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Fuji, catastropheBondsCollateralPoolAbi, provider);
            }
            else if (chainId == 80002) {
                catastropheBondsFactoryContract = new ethers.Contract(catastropheBondsFactoryAddress_Amoy, catastropheBondsFactoryAbi, provider);
                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Amoy, catastropheBondsCollateralPoolAbi, provider);
            }
            else {
                alert("Network not supported")
                return;
            }

            const catastropheBonds = await catastropheBondsFactoryContract.getAllCatastropheBonds();

            return catastropheBonds;
        }
        catch (error) {
            console.error(error.toString())
            alert("Unknown error.");
            return [];
        }
    }

    function formatString(str) {
        return str
            .split('_')                   // Split the string by underscores
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()  // Capitalize each word
            )
            .join(' ');                   // Join the words with spaces
    }

    function getProfitPercentage(costPrice, sellingPrice) {
        const profit = sellingPrice - costPrice;
        const percentage = ((profit / costPrice) * 100).toFixed(2); // Rounding to 2 decimal places
        if (Math.floor(percentage) == Math.ceil(percentage))
            return parseInt(percentage)
        return percentage;
    }

    function customToFixed(value, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return (Math.floor(value * factor) / factor).toFixed(decimalPlaces);
    }

    async function getPortfolioPositionsOfCatastropheBond(catastropheAddress, index) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);

            const signer = await provider.getSigner();

            const catastropheBondContract = new ethers.Contract(catastropheAddress, catastropheBondAbi, provider);

            const isSettled = await catastropheBondContract.isSettled();

            const longTokenBalance = parseInt(await catastropheBondContract.getBalanceOfLongToken(signer.address));
            const shortTokenBalance = parseInt(await catastropheBondContract.getBalanceOfShortToken(signer.address));


            if (isSettled && (longTokenBalance > 0 || shortTokenBalance > 0)) {
                const collateralBalanceOfCatastropheBond = await catastropheBondsCollateralPoolContract.getCollateralBalanceOfCatastropheBond(catastropheAddress);

                const catastropheCode = await catastropheBondContract.getCatastropheCode();
                const location = await catastropheBondContract.getLocation();
                const settledTo = parseInt(await catastropheBondContract.settledTo());
                const collateralRequiredForMintingAnyPositionToken = await catastropheBondContract.getCollateralRequiredForMintingAnyPositionToken();
                const collateralRequiredForMintingAnyPositionToken_formatted = parseFloat(ethers.formatUnits(collateralRequiredForMintingAnyPositionToken, "mwei"));
                const collateralBalanceOfCatastropheBond_formatted = parseFloat(ethers.formatUnits(collateralBalanceOfCatastropheBond, "mwei"));


                let catastropheEmoji;

                if (catastropheCode == 'wild_fire')
                    catastropheEmoji = '🔥';
                else if (catastropheCode == 'heatwave')
                    catastropheEmoji = '☀️';
                else if (catastropheCode == 'floods')
                    catastropheEmoji = '🌊';
                else if (catastropheCode == 'drought')
                    catastropheEmoji = '🏜️';

                const assetName = `${catastropheEmoji} ${formatString(catastropheCode)} at ${location}`;

                let portfolio_settledPositions = [];

                if (longTokenBalance) {

                    if (settledTo == 3 && collateralBalanceOfCatastropheBond == collateralRequiredForMintingAnyPositionToken * 2n) {
                        const collateralMatured = 0.95 * collateralBalanceOfCatastropheBond_formatted;
                        portfolio_settledPositions.push({
                            "positionTokenAddress": await catastropheBondContract.getLongPositionToken(),
                            "catastropheAddress": catastropheAddress,
                            "index": index,
                            "asset": assetName,
                            "position": "LONG",
                            "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                            "collateralMatured": customToFixed(collateralMatured, 2),
                            "profitPercentage": getProfitPercentage(collateralRequiredForMintingAnyPositionToken_formatted, collateralMatured)
                        });

                    }
                    else if (settledTo == 2) {
                        const collateralMatured = 0;
                        portfolio_settledPositions.push({
                            "positionTokenAddress": await catastropheBondContract.getLongPositionToken(),
                            "catastropheAddress": catastropheAddress,
                            "index": index,
                            "asset": assetName,
                            "position": "LONG",
                            "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                            "collateralMatured": collateralMatured,
                            "profitPercentage": getProfitPercentage(collateralRequiredForMintingAnyPositionToken_formatted, collateralMatured)
                        });
                    }
                    else if (settledTo == 1) {
                        const collateralMatured = collateralRequiredForMintingAnyPositionToken_formatted;
                        portfolio_settledPositions.push({
                            "positionTokenAddress": await catastropheBondContract.getLongPositionToken(),
                            "catastropheAddress": catastropheAddress,
                            "index": index,
                            "asset": assetName,
                            "position": "LONG",
                            "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                            "collateralMatured": collateralMatured,
                            "profitPercentage": getProfitPercentage(collateralRequiredForMintingAnyPositionToken_formatted, collateralMatured)
                        });
                    }

                }
                if (shortTokenBalance) {

                    if (settledTo == 3) {
                        const collateralMatured = 0;
                        portfolio_settledPositions.push({
                            "positionTokenAddress": await catastropheBondContract.getShortPositionToken(),
                            "catastropheAddress": catastropheAddress,
                            "index": index,
                            "asset": assetName,
                            "position": "SHORT",
                            "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                            "collateralMatured": collateralMatured,
                            "profitPercentage": getProfitPercentage(collateralRequiredForMintingAnyPositionToken_formatted, collateralMatured)
                        });

                    }
                    else if (settledTo == 2 && collateralBalanceOfCatastropheBond == collateralRequiredForMintingAnyPositionToken * 2n) {
                        const collateralMatured = 0.95 * collateralBalanceOfCatastropheBond_formatted;
                        portfolio_settledPositions.push({
                            "positionTokenAddress": await catastropheBondContract.getShortPositionToken(),
                            "catastropheAddress": catastropheAddress,
                            "index": index,
                            "asset": assetName,
                            "position": "SHORT",
                            "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                            "collateralMatured": customToFixed(collateralMatured, 2),
                            "profitPercentage": getProfitPercentage(collateralRequiredForMintingAnyPositionToken_formatted, collateralMatured)
                        });
                    }
                    else if (settledTo == 1) {
                        const collateralMatured = collateralRequiredForMintingAnyPositionToken_formatted;
                        portfolio_settledPositions.push({
                            "positionTokenAddress": await catastropheBondContract.getShortPositionToken(),
                            "catastropheAddress": catastropheAddress,
                            "index": index,
                            "asset": assetName,
                            "position": "SHORT",
                            "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                            "collateralMatured": collateralMatured,
                            "profitPercentage": getProfitPercentage(collateralRequiredForMintingAnyPositionToken_formatted, collateralMatured)
                        });
                    }
                }
                return portfolio_settledPositions;
            }
            return [];

        }
        catch (error) {
            console.error(error.toString())
            console.error(error.stack);
            console.log("Unknown error.");
            return [];
        }
    }

    async function getUnsettledPortfolioPositionsOfCatastropheBond(catastropheAddress, index) {
        try {
            const provider = new ethers.BrowserProvider(window.ethereum);

            const signer = await provider.getSigner();

            const catastropheBondContract = new ethers.Contract(catastropheAddress, catastropheBondAbi, provider);

            const isSettled = await catastropheBondContract.isSettled();

            const longTokenBalance = parseInt(await catastropheBondContract.getBalanceOfLongToken(signer.address));
            const shortTokenBalance = parseInt(await catastropheBondContract.getBalanceOfShortToken(signer.address));

            if (!isSettled && (longTokenBalance > 0 || shortTokenBalance > 0)) {

                const catastropheCode = await catastropheBondContract.getCatastropheCode();
                const location = await catastropheBondContract.getLocation();
                const endDate_Timestamp = await catastropheBondContract.getEndDate_Timestamp();
                const collateralRequiredForMintingAnyPositionToken = await catastropheBondContract.getCollateralRequiredForMintingAnyPositionToken();
                const collateralRequiredForMintingAnyPositionToken_formatted = parseFloat(ethers.formatUnits(collateralRequiredForMintingAnyPositionToken, "mwei"));
                let reasonOfUnsettlement;
                const epochTimestampNow = Math.floor(Date.now() / 1000);
                const endDate_Timestamp_Plus15Days = parseInt(endDate_Timestamp) + (15 * 86400);


                let catastropheEmoji;

                if (catastropheCode == 'wild_fire')
                    catastropheEmoji = '🔥';
                else if (catastropheCode == 'heatwave')
                    catastropheEmoji = '☀️';
                else if (catastropheCode == 'floods')
                    catastropheEmoji = '🌊';
                else if (catastropheCode == 'drought')
                    catastropheEmoji = '🏜️';

                const assetName = `${catastropheEmoji} ${formatString(catastropheCode)} at ${location}`;

                let portfolio_unsettledPositions = [];

                if (longTokenBalance) {
                    const totalShortTokens = await catastropheBondContract.getTotalShortTokens();

                    if (totalShortTokens == 0)
                        reasonOfUnsettlement = "Short Position Token is not minted yet."
                    else if (epochTimestampNow < endDate_Timestamp_Plus15Days)
                        reasonOfUnsettlement = "Maturity Date (plus 15 days buffer) isn't passed yet."


                    portfolio_unsettledPositions.push({
                        "positionTokenAddress": await catastropheBondContract.getLongPositionToken(),
                        "catastropheAddress": catastropheAddress,
                        "index": index,
                        "asset": assetName,
                        "position": "LONG",
                        "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                        "reasonOfUnsettlement": reasonOfUnsettlement
                    });

                }
                if (shortTokenBalance) {

                    const totalLongTokens = await catastropheBondContract.getTotalLongTokens();

                    if (totalLongTokens == 0)
                        reasonOfUnsettlement = "Long Position Token is not minted yet."
                    else if (epochTimestampNow < endDate_Timestamp_Plus15Days)
                        reasonOfUnsettlement = "Maturity Date (plus 15 days buffer) isn't passed yet."

                    portfolio_unsettledPositions.push({
                        "positionTokenAddress": await catastropheBondContract.getShortPositionToken(),
                        "catastropheAddress": catastropheAddress,
                        "index": index,
                        "asset": assetName,
                        "position": "SHORT",
                        "collateralInvested": collateralRequiredForMintingAnyPositionToken_formatted,
                        "reasonOfUnsettlement": reasonOfUnsettlement
                    });
                }
                return portfolio_unsettledPositions;
            }
            return [];

        }
        catch (error) {
            console.error(error.toString())
            console.error(error.stack);
            console.log("Unknown error.");
            return [];
        }
    }

    async function redeemPositionToken(positionTokenAddress, catastropheAddress, index) {

        let catastropheBondsCollateralPoolAddress;

        try {
            setIsRedeeming({ [positionTokenAddress]: true });

            let catastropheBondsCollateralPoolContract;

            const provider = new ethers.BrowserProvider(window.ethereum);

            const signer = await provider.getSigner();

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            let provider_receiverChain;

            let receiverChainDetails;



            if (chainId == 43113) {
                provider_receiverChain = new ethers.JsonRpcProvider(rpcUrl_Amoy);

                const catastropheBondsFactoryContract_Amoy = new ethers.Contract(catastropheBondsFactoryAddress_Amoy, catastropheBondsFactoryAbi, provider_receiverChain);

                const catastropheAddressAtSameIndex_Amoy = await catastropheBondsFactoryContract_Amoy.getCatastropheBondAtIndex(index);

                receiverChainDetails = {
                    collateralPool: catastropheBondsCollateralPoolAddress_Amoy,
                    catastropheBond: catastropheAddressAtSameIndex_Amoy,
                    chainSelector: chainSelector_Amoy
                };

                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Fuji, catastropheBondsCollateralPoolAbi, signer);
                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Fuji;
            }
            else if (chainId == 80002) {
                provider_receiverChain = new ethers.JsonRpcProvider(rpcUrl_Fuji);

                const catastropheBondsFactoryContract_Fuji = new ethers.Contract(catastropheBondsFactoryAddress_Fuji, catastropheBondsFactoryAbi, provider_receiverChain);

                const catastropheAddressAtSameIndex_Fuji = await catastropheBondsFactoryContract_Fuji.getCatastropheBondAtIndex(index);

                receiverChainDetails = {
                    collateralPool: catastropheBondsCollateralPoolAddress_Fuji,
                    catastropheBond: catastropheAddressAtSameIndex_Fuji,
                    chainSelector: chainSelector_Fuji
                };

                catastropheBondsCollateralPoolContract = new ethers.Contract(catastropheBondsCollateralPoolAddress_Amoy, catastropheBondsCollateralPoolAbi, signer);
                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Amoy;

            }

            else {
                alert("Network not supported");
                setIsRedeeming({ [positionTokenAddress]: false });
                return;
            }

            console.log(catastropheAddress, receiverChainDetails);
            console.log(catastropheBondsCollateralPoolContract);

            const tx = await catastropheBondsCollateralPoolContract.redeemPositionToken(catastropheAddress, receiverChainDetails);

            const rc = await tx.wait();

            let messageId;
            let redeemingMessage;

            rc.logs.forEach(log => {

                const parsedLog = catastropheBondsCollateralPoolContractInterface.parseLog(log);

                if (parsedLog) {
                    if (parsedLog.name == "MessageSent")
                        messageId = parsedLog.args[0];
                    else if (parsedLog.name == "TokensRedeemed") {
                        const collateralReturnedInUsdc = parsedLog.args[4];
                        const withProfit = parsedLog.args[5];
                        if (collateralReturnedInUsdc > 0) {
                            redeemingMessage = `You've successfully redeemed your ${parseFloat(ethers.formatUnits(parsedLog.args[2]))} ${parsedLog.args[3]} Position Token (${positionTokenAddress}) of Catastrophe Bond at ${parsedLog.args[0]} from your wallet address at ${parsedLog.args[1]} in exchange of ${parseFloat(ethers.formatUnits(parsedLog.args[4], "mwei"))} USDC.\n\n`;
                            if (withProfit) {
                                redeemingMessage += `Congratulations 🎉! 🤑 You've made a whopping 90% profit 💰!\n\n`
                            }
                        }

                        else
                            redeemingMessage = `You've successfully redeemed your ${parseFloat(ethers.formatUnits(parsedLog.args[2]))} ${parsedLog.args[3]} Position Token (${positionTokenAddress}) of Catastrophe Bond at ${parsedLog.args[0]} from your wallet address at ${parsedLog.args[1]}.\n\n`;

                    }
                }
            });

            if (messageId && redeemingMessage) {
                setTxSuccess(true);
                setMessage(redeemingMessage);
                setMessageId(messageId);
                setIsRedeeming({ [positionTokenAddress]: false });
            }

            // alert(`${mintingMessage}\n\nPlease visit https://ccip.chain.link/msg/${messageId} to check the cross-chain minting status of your Long Position Token.`);

        }
        catch (error) {
            setIsRedeeming({ [positionTokenAddress]: false });
            try {
                const revertData = error.data
                // console.log(error)
                const decodedError = catastropheBondsCollateralPoolContractInterface.parseError(revertData)
                if (decodedError) {
                    if (decodedError.name == 'CatastropheBondsCollateralPool__CatastropheBondIsNotSettledYet') {
                        console.log(`Transaction failed: Catastrophe Bond is not settled yet.`);
                    }
                    else if (decodedError.name == "CatastropheBondsCollateralPool__AlreadyRedeemed") {
                        console.log(`Transaction failed: Position Tokens for this Catastrophe Bond are already redeemed.`);
                    }
                    else if (decodedError.name == "CatastropheBondsCollateralPool__NothingToRedeem") {
                        console.log("Transaction failed: You don't have any Position Token in your connected wallet.");
                    }
                    else if (decodedError.name == "CatastropheBondsCollateralPool__NotFundedWithEnoughLINK") {
                        alert(`Transaction failed: Please fund the CatastropheBondsCollateralPool contract at ${catastropheBondsCollateralPoolAddress} with at least ${parseFloat(ethers.formatUnits(decodedError.args[0]))} LINK token.`);
                    }
                    else {
                        console.error(decodedError.name);
                    }

                }
                else {
                    console.error(error.toString());
                    console.log("Transaction failed: Unknown error.");
                }
            }
            catch (error) {
                console.log("Error inside the 1st catch...")
                console.error(error.toString());
                console.error(error.stack);
                alert("Transaction failed: Unknown error.");
            }

        }
    }

    useEffect(() => {
        const fetchPortfolioPositions = async () => {
            try {
                const catastropheBonds = await getAllCatastropheBonds();
                let portfolio_settledPositions = [];
                let portfolio_unsettledPositions = [];
                for (var i = 0; i < catastropheBonds.length; i++) {
                    portfolio_settledPositions.push(...(await getPortfolioPositionsOfCatastropheBond(catastropheBonds[i], i)));
                    portfolio_unsettledPositions.push(...(await getUnsettledPortfolioPositionsOfCatastropheBond(catastropheBonds[i], i)));
                }

                setPortfolio_settledPositions(portfolio_settledPositions);
                setPortfolio_unsettledPositions(portfolio_unsettledPositions);
                setIsLoading(false);

            } catch (error) {
                console.error('Error fetching data:', error);
                setIsLoading(false);
            }
        };
        fetchPortfolioPositions();
    }, []);


    const HandleRedeemClick = async (position, positionTokenAddress, catastropheAddress, index) => {

        console.log('redeem clicked for: ', positionTokenAddress, catastropheAddress);

        await redeemPositionToken(positionTokenAddress, catastropheAddress, index);

    };


    return (
        <div>
            {txSuccess && <AlertWithUrl message={message} messageId={messageId} typeOfMessage="redeeming" target="Position Token" onClose={() => setTxSuccess(false)} />}
            <div className="row">

                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex flex-row justify-content-between">
                                {/* <h4 className="card-title mb-1">Insurance positions</h4> */}

                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Matured Positions</h4>

                                            <div className="table-responsive">
                                                {isLoading ? (
                                                    <p>Loading...</p>
                                                ) : portfolio_settledPositions.length ? (
                                                    <table className="table table-hover">

                                                        <thead>
                                                            <tr>
                                                                <th>Asset</th>
                                                                <th>Position</th>
                                                                <th className="two-line-header">
                                                                    Collateral Invested <br /> (in USDC)
                                                                </th>
                                                                <th className="two-line-header">
                                                                    Collateral Matured  <br /> (in USDC)
                                                                </th>
                                                                <th>Profit (%)</th>
                                                                <th>Action</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {portfolio_settledPositions.map((portfolioPosition) => (
                                                                <tr key={portfolioPosition.positionTokenAddress}>
                                                                    <td>{portfolioPosition.asset}</td>
                                                                    <td>{portfolioPosition.position}</td>
                                                                    <td className="center-align">{portfolioPosition.collateralInvested}</td>
                                                                    <td className="center-align">{portfolioPosition.collateralMatured}</td>
                                                                    <td className="center-align">{portfolioPosition.profitPercentage}</td>
                                                                    <td>
                                                                        {isRedeeming[portfolioPosition.positionTokenAddress] ? <p>Redeeming...</p> : <button className="btn badge-outline-success" onClick={() => HandleRedeemClick(portfolioPosition.position, portfolioPosition.positionTokenAddress, portfolioPosition.catastropheAddress, portfolioPosition.index)}>Redeem</button>}
                                                                    </td>



                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    <p>No matured positions available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex flex-row justify-content-between">
                                {/* <h4 className="card-title mb-1">Insurance positions</h4> */}

                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Unsettled Positions</h4>

                                            <div className="table-responsive">
                                                {isLoading ? (
                                                    <p>Loading...</p>
                                                ) : portfolio_unsettledPositions.length ? (
                                                    <table className="table table-hover">

                                                        <thead>
                                                            <tr>
                                                                <th>Asset</th>
                                                                <th>Position</th>
                                                                <th className="two-line-header">
                                                                    Collateral Invested <br /> (in USDC)
                                                                </th>

                                                                <th>Unsettlement Reason</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {portfolio_unsettledPositions.map((portfolioPosition) => (
                                                                <tr key={portfolioPosition.positionTokenAddress}>
                                                                    <td>{portfolioPosition.asset}</td>
                                                                    <td>{portfolioPosition.position}</td>
                                                                    <td className="center-align">{portfolioPosition.collateralInvested}</td>
                                                                    <td>{portfolioPosition.reasonOfUnsettlement}</td>

                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                ) : (
                                                    <p>No unsettled positions available.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}


export default Portfolio